// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AwscCallDispositionPopup-module__font-s-10___TGS2o {
  font-size: 10px !important;
}

.AwscCallDispositionPopup-module__font-s-12___elWda {
  font-size: 12px !important;
}

.AwscCallDispositionPopup-module__font-s-13___edDoS {
  font-size: 13px !important;
}

.AwscCallDispositionPopup-module__font-s-14___TPo7v {
  font-size: 14px !important;
}

.AwscCallDispositionPopup-module__font-s-15___WNiB9 {
  font-size: 15px !important;
}

.AwscCallDispositionPopup-module__font-s-16___HWLd0 {
  font-size: 16px !important;
}

.AwscCallDispositionPopup-module__font-s-18___M5NS8 {
  font-size: 18px !important;
}

.AwscCallDispositionPopup-module__font-s-20___JwRxV {
  font-size: 20px !important;
}

.AwscCallDispositionPopup-module__font-s-22___xwYSn {
  font-size: 22px !important;
}

.AwscCallDispositionPopup-module__font-s-28___oM_G7 {
  font-size: 28px !important;
}

.AwscCallDispositionPopup-module__font-w-400___DK6Ep {
  font-weight: 400 !important;
}

.AwscCallDispositionPopup-module__font-w-500___JtA7V {
  font-weight: 500 !important;
}

.AwscCallDispositionPopup-module__font-w-600___zJe9j {
  font-weight: 600 !important;
}

.AwscCallDispositionPopup-module__font-w-700___qCBog {
  font-weight: 700 !important;
}

.AwscCallDispositionPopup-module__p-5___YEqU7 {
  padding: 5px !important;
}

.AwscCallDispositionPopup-module__p-12___zAtI2 {
  padding: 12px !important;
}

.AwscCallDispositionPopup-module__p-16___TO1xH {
  padding: 16px !important;
}

.AwscCallDispositionPopup-module__p-30___ABNcv {
  padding: 30px !important;
}

.AwscCallDispositionPopup-module__p-b-0___eJB9B {
  padding-bottom: 0 !important;
}

.AwscCallDispositionPopup-module__p-b-5___s5k63 {
  padding-bottom: 5px !important;
}

.AwscCallDispositionPopup-module__p-b-10___Bnz4W {
  padding-bottom: 10px !important;
}

.AwscCallDispositionPopup-module__p-b-12___CzX9y {
  padding-bottom: 12px !important;
}

.AwscCallDispositionPopup-module__p-b-16___abC3l {
  padding-bottom: 16px !important;
}

.AwscCallDispositionPopup-module__p-b-18___JqF63 {
  padding-bottom: 18px !important;
}

.AwscCallDispositionPopup-module__p-b-20___aMLhG {
  padding-bottom: 20px !important;
}

.AwscCallDispositionPopup-module__p-b-25___alrbO {
  padding-bottom: 25px !important;
}

.AwscCallDispositionPopup-module__p-b-30___Y6xgx {
  padding-bottom: 30px !important;
}

.AwscCallDispositionPopup-module__p-b-50___l9d5H {
  padding-bottom: 50px !important;
}

.AwscCallDispositionPopup-module__p-t-0___YiVYN {
  padding-top: 0 !important;
}

.AwscCallDispositionPopup-module__p-t-12___H3RLb {
  padding-top: 12px !important;
}

.AwscCallDispositionPopup-module__p-t-16___B_YlW {
  padding-top: 16px !important;
}

.AwscCallDispositionPopup-module__p-t-18___O7dRl {
  padding-top: 18px !important;
}

.AwscCallDispositionPopup-module__p-t-20___V9gWV {
  padding-top: 20px !important;
}

.AwscCallDispositionPopup-module__p-t-30___mJBgE {
  padding-top: 30px !important;
}

.AwscCallDispositionPopup-module__p-t-40___bPFRh {
  padding-top: 40px !important;
}

.AwscCallDispositionPopup-module__p-t-50___SptMw {
  padding-top: 50px !important;
}

.AwscCallDispositionPopup-module__p-l-20___ICcOF {
  padding-left: 20px !important;
}

.AwscCallDispositionPopup-module__p-l-30___AjrVN {
  padding-left: 30px !important;
}

.AwscCallDispositionPopup-module__p-l-40___m3GPP {
  padding-left: 40px !important;
}

.AwscCallDispositionPopup-module__p-r-16___H1AGO {
  padding-right: 16px !important;
}

.AwscCallDispositionPopup-module__p-r-20___lqSww {
  padding-right: 20px !important;
}

.AwscCallDispositionPopup-module__p-r-30___DXfja {
  padding-right: 30px !important;
}

.AwscCallDispositionPopup-module__p-r-50___xxJEK {
  padding-right: 50px !important;
}

.AwscCallDispositionPopup-module__p-r-60___fLQSL {
  padding-right: 60px !important;
}

.AwscCallDispositionPopup-module__m-b-1___sUSve {
  margin-bottom: 1px !important;
}

.AwscCallDispositionPopup-module__m-b-2___eNytj {
  margin-bottom: 2px !important;
}

.AwscCallDispositionPopup-module__m-b-6___IN03H {
  margin-bottom: 6px !important;
}

.AwscCallDispositionPopup-module__m-b-8___fM9bC {
  margin-bottom: 8px !important;
}

.AwscCallDispositionPopup-module__m-b-10___sX_Kk {
  margin-bottom: 10px !important;
}

.AwscCallDispositionPopup-module__m-b-14___txqzS {
  margin-bottom: 14px !important;
}

.AwscCallDispositionPopup-module__m-b-16___tB7kq {
  margin-bottom: 16px !important;
}

.AwscCallDispositionPopup-module__m-b-20___o95_I {
  margin-bottom: 20px !important;
}

.AwscCallDispositionPopup-module__m-b-22___it4YX {
  margin-bottom: 22px !important;
}

.AwscCallDispositionPopup-module__m-b-24___aBKLn {
  margin-bottom: 24px !important;
}

.AwscCallDispositionPopup-module__m-b-30___yUeBQ {
  margin-bottom: 30px !important;
}

.AwscCallDispositionPopup-module__m-b-32___FXs1n {
  margin-bottom: 32px !important;
}

.AwscCallDispositionPopup-module__m-b-40___MYW3I {
  margin-bottom: 40px !important;
}

.AwscCallDispositionPopup-module__m-t-2___HSbbJ {
  margin-top: 2px !important;
}

.AwscCallDispositionPopup-module__m-t-3___ZEW00 {
  margin-top: 3px !important;
}

.AwscCallDispositionPopup-module__m-t-4___JehCR {
  margin-top: 4px !important;
}

.AwscCallDispositionPopup-module__m-t-5___wc_Ar {
  margin-top: 5px !important;
}

.AwscCallDispositionPopup-module__m-t-8___Xb3rf {
  margin-top: 8px !important;
}

.AwscCallDispositionPopup-module__m-t-10___PzQsh {
  margin-top: 10px !important;
}

.AwscCallDispositionPopup-module__m-t-15___rbg2w {
  margin-top: 15px !important;
}

.AwscCallDispositionPopup-module__m-t-16____3t3N {
  margin-top: 16px !important;
}

.AwscCallDispositionPopup-module__m-t-20___wgGZ9 {
  margin-top: 20px !important;
}

.AwscCallDispositionPopup-module__m-t-22___iQON5 {
  margin-top: 22px !important;
}

.AwscCallDispositionPopup-module__m-t-30___VRqsX {
  margin-top: 30px !important;
}

.AwscCallDispositionPopup-module__m-t-32___gYRT9 {
  margin-top: 32px !important;
}

.AwscCallDispositionPopup-module__m-l-auto___f0cv8 {
  margin-left: auto !important;
}

.AwscCallDispositionPopup-module__m-l-4___JItxl {
  margin-left: 4px !important;
}

.AwscCallDispositionPopup-module__m-l-5___g64Xz {
  margin-left: 5px !important;
}

.AwscCallDispositionPopup-module__m-l-6___XW0CZ {
  margin-left: 6px !important;
}

.AwscCallDispositionPopup-module__m-l-8___j0nKU {
  margin-left: 8px !important;
}

.AwscCallDispositionPopup-module__m-l-10___EGxRz {
  margin-left: 10px !important;
}

.AwscCallDispositionPopup-module__m-l-16___yiDGE {
  margin-left: 16px !important;
}

.AwscCallDispositionPopup-module__m-l-20___oTDg9 {
  margin-left: 20px !important;
}

.AwscCallDispositionPopup-module__m-l-24___Tmjg6 {
  margin-left: 24px !important;
}

.AwscCallDispositionPopup-module__m-l-30___Ci8ll {
  margin-left: 30px !important;
}

.AwscCallDispositionPopup-module__m-l-35___Lu1_l {
  margin-left: 35px !important;
}

.AwscCallDispositionPopup-module__m-l-40___tOHY4 {
  margin-left: 40px !important;
}

.AwscCallDispositionPopup-module__m-r-8___YpDCU {
  margin-right: 8px !important;
}

.AwscCallDispositionPopup-module__m-r-10___jLtGs {
  margin-right: 10px !important;
}

.AwscCallDispositionPopup-module__m-r-16___qLszj {
  margin-right: 16px !important;
}

.AwscCallDispositionPopup-module__m-r-20___SImIf {
  margin-right: 20px !important;
}

.AwscCallDispositionPopup-module__m-r-24___dxMy9 {
  margin-right: 24px !important;
}

.AwscCallDispositionPopup-module__m-r-30___touB9 {
  margin-right: 30px !important;
}

.AwscCallDispositionPopup-module__m-r-40___omVTO {
  margin-right: 40px !important;
}

.AwscCallDispositionPopup-module__border-r-3___ChtGi {
  border-radius: 3px !important;
}

.AwscCallDispositionPopup-module__border-r-4___wFG1B {
  border-radius: 4px !important;
}

.AwscCallDispositionPopup-module__border-r-6___Oty_m {
  border-radius: 6px !important;
}

.AwscCallDispositionPopup-module__border-r-10___f84oX {
  border-radius: 10px !important;
}

.AwscCallDispositionPopup-module__border-r-12___Dbcsp {
  border-radius: 12px !important;
}

.AwscCallDispositionPopup-module__border-r-16___ZrR0Z {
  border-radius: 16px !important;
}

.AwscCallDispositionPopup-module__border-r-50___CmcrK {
  border-radius: 50% !important;
}

.AwscCallDispositionPopup-module__primary-border___RjrIz {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.AwscCallDispositionPopup-module__primary-border-b___HiX9g {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.AwscCallDispositionPopup-module__primary-border-t___v2v2L {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.AwscCallDispositionPopup-module__primary-border-l___prmZJ {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.AwscCallDispositionPopup-module__primary-border-r___bucKo {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.AwscCallDispositionPopup-module__secondary-border___HvdoN {
  border: 1px solid #637768;
}

.AwscCallDispositionPopup-module__secondary-border-b___efsgT {
  border-bottom: 1px solid #637768;
}

.AwscCallDispositionPopup-module__secondary-border-t___JdfVL {
  border-top: 1px solid #637768;
}

.AwscCallDispositionPopup-module__secondary-border-l___ynihy {
  border-left: 1px solid #637768;
}

.AwscCallDispositionPopup-module__secondary-border-r___YI02h {
  border-right: 1px solid #637768;
}

.AwscCallDispositionPopup-module__gap-0___whtDH {
  gap: 0 !important;
}

.AwscCallDispositionPopup-module__gap-2___gN63T {
  gap: 2px !important;
}

.AwscCallDispositionPopup-module__gap-4___HF9O8 {
  gap: 4px !important;
}

.AwscCallDispositionPopup-module__gap-5___UfJgV {
  gap: 5px !important;
}

.AwscCallDispositionPopup-module__gap-6___PkvDk {
  gap: 6px !important;
}

.AwscCallDispositionPopup-module__gap-8___tXydq {
  gap: 8px !important;
}

.AwscCallDispositionPopup-module__gap-10___pdoJ5 {
  gap: 10px !important;
}

.AwscCallDispositionPopup-module__gap-12___m5oNa {
  gap: 12px !important;
}

.AwscCallDispositionPopup-module__gap-14___g9aTF {
  gap: 14px !important;
}

.AwscCallDispositionPopup-module__gap-16___hA3Hl {
  gap: 16px !important;
}

.AwscCallDispositionPopup-module__gap-18___GO_C7 {
  gap: 18px !important;
}

.AwscCallDispositionPopup-module__gap-20___r8CSs {
  gap: 20px !important;
}

.AwscCallDispositionPopup-module__gap-24___JXl3S {
  gap: 24px !important;
}

.AwscCallDispositionPopup-module__gap-26___fU9G5 {
  gap: 26px !important;
}

.AwscCallDispositionPopup-module__gap-30___hxlTc {
  gap: 30px !important;
}

.AwscCallDispositionPopup-module__gap-32___BzdsN {
  gap: 32px !important;
}

.AwscCallDispositionPopup-module__gap-40___iQIqZ {
  gap: 40px !important;
}

.AwscCallDispositionPopup-module__gap-50___sMmla {
  gap: 50px !important;
}

.AwscCallDispositionPopup-module__flex-1___U4tbu {
  flex: 1;
}

.AwscCallDispositionPopup-module__flex-none___xYfkX {
  flex: none !important;
}

.AwscCallDispositionPopup-module__flex-column___TSoI0 {
  display: flex;
  flex-direction: column !important;
}

.AwscCallDispositionPopup-module__flex-row___qDhJz {
  display: flex;
  flex-direction: row !important;
}

.AwscCallDispositionPopup-module__vertically-centered___lxnbu {
  display: flex;
  align-items: center !important;
}

.AwscCallDispositionPopup-module__horizontally-centered___OHHiM {
  display: flex;
  justify-content: center !important;
}

.AwscCallDispositionPopup-module__horizontally-end___dwPNm {
  display: flex;
  justify-content: end !important;
}

.AwscCallDispositionPopup-module__vertically-start___HTXsv {
  display: flex;
  align-items: start !important;
}

.AwscCallDispositionPopup-module__space-between___wfylU {
  display: flex;
  justify-content: space-between !important;
}

.AwscCallDispositionPopup-module__flex-wrap___YPHms {
  flex-wrap: wrap !important;
}

.AwscCallDispositionPopup-module__height-100___vbWqp {
  height: 100%;
}

.AwscCallDispositionPopup-module__width-50___Pq9Qk {
  width: 50% !important;
}

.AwscCallDispositionPopup-module__width-100___JuTuY {
  width: 100%;
}

.AwscCallDispositionPopup-module__cursor-pointer___dj_N1 {
  cursor: pointer;
}

.AwscCallDispositionPopup-module__cursor-not-allowed___klPwl {
  cursor: not-allowed !important;
}

.AwscCallDispositionPopup-module__absolute-centered___WZYDq {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.AwscCallDispositionPopup-module__absolute___Apguj {
  position: absolute;
}

.AwscCallDispositionPopup-module__relative___ygm5l {
  position: relative;
}

.AwscCallDispositionPopup-module__fixed___Nk4nG {
  position: fixed;
}

.AwscCallDispositionPopup-module__visible___fxYXa {
  opacity: 1;
}

.AwscCallDispositionPopup-module__invisible___axHCK {
  opacity: 0;
}

.AwscCallDispositionPopup-module__col-90___ein8h {
  width: 90% !important;
}

.AwscCallDispositionPopup-module__col-auto___TiJvq {
  width: auto !important;
}

.AwscCallDispositionPopup-module__medical-tabs___fM9A6 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.AwscCallDispositionPopup-module__medical-table-new___UrTcr {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.AwscCallDispositionPopup-module__medical-table-new___UrTcr:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.AwscCallDispositionPopup-module__medical-table-new___UrTcr::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.AwscCallDispositionPopup-module__medical-table-new___UrTcr::-webkit-scrollbar-track {
  display: none;
}
.AwscCallDispositionPopup-module__medical-table-new___UrTcr.AwscCallDispositionPopup-module__no-pagination___qrSIq {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.AwscCallDispositionPopup-module__medical-table-new___UrTcr.AwscCallDispositionPopup-module__no-pagination___qrSIq:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.AwscCallDispositionPopup-module__medical-table-new___UrTcr.AwscCallDispositionPopup-module__no-pagination___qrSIq::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.AwscCallDispositionPopup-module__medical-table-new___UrTcr.AwscCallDispositionPopup-module__no-pagination___qrSIq::-webkit-scrollbar-track {
  display: none;
}

.AwscCallDispositionPopup-module__medical-table-empty___g0EUp {
  padding: 14px 40px !important;
}

.AwscCallDispositionPopup-module__icon-btn___ffYot {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.AwscCallDispositionPopup-module__search-icon___IKP2x {
  width: 24px;
  height: 24px;
  align-self: center;
}

.AwscCallDispositionPopup-module__disable-select___AWUMN {
  user-select: none;
}

.AwscCallDispositionPopup-module__break-word___aXWsY {
  word-break: break-word;
}

.AwscCallDispositionPopup-module__popup-clear-btn___SkPW8 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.AwscCallDispositionPopup-module__scroll-m-b-20___JYUrb {
  scroll-margin-bottom: 20px;
}

.AwscCallDispositionPopup-module__container___F8Jyx {
  display: flex;
  flex-direction: column;
  padding: 20px 41px 10px 41px;
  align-items: center;
}
.AwscCallDispositionPopup-module__container___F8Jyx .AwscCallDispositionPopup-module__radioItem___MOAXZ {
  width: 100%;
  padding: 10px;
  border: 1px solid #859989;
  border-radius: 6px;
  margin-bottom: 10px !important;
}

.AwscCallDispositionPopup-module__buttonsContainer___pCDXa {
  justify-content: end;
  margin: 0 auto 30px auto;
  display: flex;
  gap: 16px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/AwscCallDispositionPopup/AwscCallDispositionPopup.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,sBAAA;EACA,4BAAA;EACA,mBAAA;AA8pBF;AA5pBE;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,8BAAA;AA8pBJ;;AA1pBA;EACE,oBAAA;EACA,wBAAA;EACA,aAAA;EACA,SAAA;AA6pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  display: flex;\n  flex-direction: column;\n  padding: 20px 41px 10px 41px;\n  align-items: center;\n\n  .radioItem {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid get-color(greenNew, medium);\n    border-radius: 6px;\n    margin-bottom: 10px !important;\n  }\n}\n\n.buttonsContainer {\n  justify-content: end;\n  margin: 0 auto 30px auto;\n  display: flex;\n  gap: 16px;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `AwscCallDispositionPopup-module__font-s-10___TGS2o`,
	"fontS12": `AwscCallDispositionPopup-module__font-s-12___elWda`,
	"fontS13": `AwscCallDispositionPopup-module__font-s-13___edDoS`,
	"fontS14": `AwscCallDispositionPopup-module__font-s-14___TPo7v`,
	"fontS15": `AwscCallDispositionPopup-module__font-s-15___WNiB9`,
	"fontS16": `AwscCallDispositionPopup-module__font-s-16___HWLd0`,
	"fontS18": `AwscCallDispositionPopup-module__font-s-18___M5NS8`,
	"fontS20": `AwscCallDispositionPopup-module__font-s-20___JwRxV`,
	"fontS22": `AwscCallDispositionPopup-module__font-s-22___xwYSn`,
	"fontS28": `AwscCallDispositionPopup-module__font-s-28___oM_G7`,
	"fontW400": `AwscCallDispositionPopup-module__font-w-400___DK6Ep`,
	"fontW500": `AwscCallDispositionPopup-module__font-w-500___JtA7V`,
	"fontW600": `AwscCallDispositionPopup-module__font-w-600___zJe9j`,
	"fontW700": `AwscCallDispositionPopup-module__font-w-700___qCBog`,
	"p5": `AwscCallDispositionPopup-module__p-5___YEqU7`,
	"p12": `AwscCallDispositionPopup-module__p-12___zAtI2`,
	"p16": `AwscCallDispositionPopup-module__p-16___TO1xH`,
	"p30": `AwscCallDispositionPopup-module__p-30___ABNcv`,
	"pB0": `AwscCallDispositionPopup-module__p-b-0___eJB9B`,
	"pB5": `AwscCallDispositionPopup-module__p-b-5___s5k63`,
	"pB10": `AwscCallDispositionPopup-module__p-b-10___Bnz4W`,
	"pB12": `AwscCallDispositionPopup-module__p-b-12___CzX9y`,
	"pB16": `AwscCallDispositionPopup-module__p-b-16___abC3l`,
	"pB18": `AwscCallDispositionPopup-module__p-b-18___JqF63`,
	"pB20": `AwscCallDispositionPopup-module__p-b-20___aMLhG`,
	"pB25": `AwscCallDispositionPopup-module__p-b-25___alrbO`,
	"pB30": `AwscCallDispositionPopup-module__p-b-30___Y6xgx`,
	"pB50": `AwscCallDispositionPopup-module__p-b-50___l9d5H`,
	"pT0": `AwscCallDispositionPopup-module__p-t-0___YiVYN`,
	"pT12": `AwscCallDispositionPopup-module__p-t-12___H3RLb`,
	"pT16": `AwscCallDispositionPopup-module__p-t-16___B_YlW`,
	"pT18": `AwscCallDispositionPopup-module__p-t-18___O7dRl`,
	"pT20": `AwscCallDispositionPopup-module__p-t-20___V9gWV`,
	"pT30": `AwscCallDispositionPopup-module__p-t-30___mJBgE`,
	"pT40": `AwscCallDispositionPopup-module__p-t-40___bPFRh`,
	"pT50": `AwscCallDispositionPopup-module__p-t-50___SptMw`,
	"pL20": `AwscCallDispositionPopup-module__p-l-20___ICcOF`,
	"pL30": `AwscCallDispositionPopup-module__p-l-30___AjrVN`,
	"pL40": `AwscCallDispositionPopup-module__p-l-40___m3GPP`,
	"pR16": `AwscCallDispositionPopup-module__p-r-16___H1AGO`,
	"pR20": `AwscCallDispositionPopup-module__p-r-20___lqSww`,
	"pR30": `AwscCallDispositionPopup-module__p-r-30___DXfja`,
	"pR50": `AwscCallDispositionPopup-module__p-r-50___xxJEK`,
	"pR60": `AwscCallDispositionPopup-module__p-r-60___fLQSL`,
	"mB1": `AwscCallDispositionPopup-module__m-b-1___sUSve`,
	"mB2": `AwscCallDispositionPopup-module__m-b-2___eNytj`,
	"mB6": `AwscCallDispositionPopup-module__m-b-6___IN03H`,
	"mB8": `AwscCallDispositionPopup-module__m-b-8___fM9bC`,
	"mB10": `AwscCallDispositionPopup-module__m-b-10___sX_Kk`,
	"mB14": `AwscCallDispositionPopup-module__m-b-14___txqzS`,
	"mB16": `AwscCallDispositionPopup-module__m-b-16___tB7kq`,
	"mB20": `AwscCallDispositionPopup-module__m-b-20___o95_I`,
	"mB22": `AwscCallDispositionPopup-module__m-b-22___it4YX`,
	"mB24": `AwscCallDispositionPopup-module__m-b-24___aBKLn`,
	"mB30": `AwscCallDispositionPopup-module__m-b-30___yUeBQ`,
	"mB32": `AwscCallDispositionPopup-module__m-b-32___FXs1n`,
	"mB40": `AwscCallDispositionPopup-module__m-b-40___MYW3I`,
	"mT2": `AwscCallDispositionPopup-module__m-t-2___HSbbJ`,
	"mT3": `AwscCallDispositionPopup-module__m-t-3___ZEW00`,
	"mT4": `AwscCallDispositionPopup-module__m-t-4___JehCR`,
	"mT5": `AwscCallDispositionPopup-module__m-t-5___wc_Ar`,
	"mT8": `AwscCallDispositionPopup-module__m-t-8___Xb3rf`,
	"mT10": `AwscCallDispositionPopup-module__m-t-10___PzQsh`,
	"mT15": `AwscCallDispositionPopup-module__m-t-15___rbg2w`,
	"mT16": `AwscCallDispositionPopup-module__m-t-16____3t3N`,
	"mT20": `AwscCallDispositionPopup-module__m-t-20___wgGZ9`,
	"mT22": `AwscCallDispositionPopup-module__m-t-22___iQON5`,
	"mT30": `AwscCallDispositionPopup-module__m-t-30___VRqsX`,
	"mT32": `AwscCallDispositionPopup-module__m-t-32___gYRT9`,
	"mLAuto": `AwscCallDispositionPopup-module__m-l-auto___f0cv8`,
	"mL4": `AwscCallDispositionPopup-module__m-l-4___JItxl`,
	"mL5": `AwscCallDispositionPopup-module__m-l-5___g64Xz`,
	"mL6": `AwscCallDispositionPopup-module__m-l-6___XW0CZ`,
	"mL8": `AwscCallDispositionPopup-module__m-l-8___j0nKU`,
	"mL10": `AwscCallDispositionPopup-module__m-l-10___EGxRz`,
	"mL16": `AwscCallDispositionPopup-module__m-l-16___yiDGE`,
	"mL20": `AwscCallDispositionPopup-module__m-l-20___oTDg9`,
	"mL24": `AwscCallDispositionPopup-module__m-l-24___Tmjg6`,
	"mL30": `AwscCallDispositionPopup-module__m-l-30___Ci8ll`,
	"mL35": `AwscCallDispositionPopup-module__m-l-35___Lu1_l`,
	"mL40": `AwscCallDispositionPopup-module__m-l-40___tOHY4`,
	"mR8": `AwscCallDispositionPopup-module__m-r-8___YpDCU`,
	"mR10": `AwscCallDispositionPopup-module__m-r-10___jLtGs`,
	"mR16": `AwscCallDispositionPopup-module__m-r-16___qLszj`,
	"mR20": `AwscCallDispositionPopup-module__m-r-20___SImIf`,
	"mR24": `AwscCallDispositionPopup-module__m-r-24___dxMy9`,
	"mR30": `AwscCallDispositionPopup-module__m-r-30___touB9`,
	"mR40": `AwscCallDispositionPopup-module__m-r-40___omVTO`,
	"borderR3": `AwscCallDispositionPopup-module__border-r-3___ChtGi`,
	"borderR4": `AwscCallDispositionPopup-module__border-r-4___wFG1B`,
	"borderR6": `AwscCallDispositionPopup-module__border-r-6___Oty_m`,
	"borderR10": `AwscCallDispositionPopup-module__border-r-10___f84oX`,
	"borderR12": `AwscCallDispositionPopup-module__border-r-12___Dbcsp`,
	"borderR16": `AwscCallDispositionPopup-module__border-r-16___ZrR0Z`,
	"borderR50": `AwscCallDispositionPopup-module__border-r-50___CmcrK`,
	"primaryBorder": `AwscCallDispositionPopup-module__primary-border___RjrIz`,
	"primaryBorderB": `AwscCallDispositionPopup-module__primary-border-b___HiX9g`,
	"primaryBorderT": `AwscCallDispositionPopup-module__primary-border-t___v2v2L`,
	"primaryBorderL": `AwscCallDispositionPopup-module__primary-border-l___prmZJ`,
	"primaryBorderR": `AwscCallDispositionPopup-module__primary-border-r___bucKo`,
	"secondaryBorder": `AwscCallDispositionPopup-module__secondary-border___HvdoN`,
	"secondaryBorderB": `AwscCallDispositionPopup-module__secondary-border-b___efsgT`,
	"secondaryBorderT": `AwscCallDispositionPopup-module__secondary-border-t___JdfVL`,
	"secondaryBorderL": `AwscCallDispositionPopup-module__secondary-border-l___ynihy`,
	"secondaryBorderR": `AwscCallDispositionPopup-module__secondary-border-r___YI02h`,
	"gap0": `AwscCallDispositionPopup-module__gap-0___whtDH`,
	"gap2": `AwscCallDispositionPopup-module__gap-2___gN63T`,
	"gap4": `AwscCallDispositionPopup-module__gap-4___HF9O8`,
	"gap5": `AwscCallDispositionPopup-module__gap-5___UfJgV`,
	"gap6": `AwscCallDispositionPopup-module__gap-6___PkvDk`,
	"gap8": `AwscCallDispositionPopup-module__gap-8___tXydq`,
	"gap10": `AwscCallDispositionPopup-module__gap-10___pdoJ5`,
	"gap12": `AwscCallDispositionPopup-module__gap-12___m5oNa`,
	"gap14": `AwscCallDispositionPopup-module__gap-14___g9aTF`,
	"gap16": `AwscCallDispositionPopup-module__gap-16___hA3Hl`,
	"gap18": `AwscCallDispositionPopup-module__gap-18___GO_C7`,
	"gap20": `AwscCallDispositionPopup-module__gap-20___r8CSs`,
	"gap24": `AwscCallDispositionPopup-module__gap-24___JXl3S`,
	"gap26": `AwscCallDispositionPopup-module__gap-26___fU9G5`,
	"gap30": `AwscCallDispositionPopup-module__gap-30___hxlTc`,
	"gap32": `AwscCallDispositionPopup-module__gap-32___BzdsN`,
	"gap40": `AwscCallDispositionPopup-module__gap-40___iQIqZ`,
	"gap50": `AwscCallDispositionPopup-module__gap-50___sMmla`,
	"flex1": `AwscCallDispositionPopup-module__flex-1___U4tbu`,
	"flexNone": `AwscCallDispositionPopup-module__flex-none___xYfkX`,
	"flexColumn": `AwscCallDispositionPopup-module__flex-column___TSoI0`,
	"flexRow": `AwscCallDispositionPopup-module__flex-row___qDhJz`,
	"verticallyCentered": `AwscCallDispositionPopup-module__vertically-centered___lxnbu`,
	"horizontallyCentered": `AwscCallDispositionPopup-module__horizontally-centered___OHHiM`,
	"horizontallyEnd": `AwscCallDispositionPopup-module__horizontally-end___dwPNm`,
	"verticallyStart": `AwscCallDispositionPopup-module__vertically-start___HTXsv`,
	"spaceBetween": `AwscCallDispositionPopup-module__space-between___wfylU`,
	"flexWrap": `AwscCallDispositionPopup-module__flex-wrap___YPHms`,
	"height100": `AwscCallDispositionPopup-module__height-100___vbWqp`,
	"width50": `AwscCallDispositionPopup-module__width-50___Pq9Qk`,
	"width100": `AwscCallDispositionPopup-module__width-100___JuTuY`,
	"cursorPointer": `AwscCallDispositionPopup-module__cursor-pointer___dj_N1`,
	"cursorNotAllowed": `AwscCallDispositionPopup-module__cursor-not-allowed___klPwl`,
	"absoluteCentered": `AwscCallDispositionPopup-module__absolute-centered___WZYDq`,
	"absolute": `AwscCallDispositionPopup-module__absolute___Apguj`,
	"relative": `AwscCallDispositionPopup-module__relative___ygm5l`,
	"fixed": `AwscCallDispositionPopup-module__fixed___Nk4nG`,
	"visible": `AwscCallDispositionPopup-module__visible___fxYXa`,
	"invisible": `AwscCallDispositionPopup-module__invisible___axHCK`,
	"col90": `AwscCallDispositionPopup-module__col-90___ein8h`,
	"colAuto": `AwscCallDispositionPopup-module__col-auto___TiJvq`,
	"medicalTabs": `AwscCallDispositionPopup-module__medical-tabs___fM9A6`,
	"medicalTableNew": `AwscCallDispositionPopup-module__medical-table-new___UrTcr`,
	"noPagination": `AwscCallDispositionPopup-module__no-pagination___qrSIq`,
	"medicalTableEmpty": `AwscCallDispositionPopup-module__medical-table-empty___g0EUp`,
	"iconBtn": `AwscCallDispositionPopup-module__icon-btn___ffYot`,
	"searchIcon": `AwscCallDispositionPopup-module__search-icon___IKP2x`,
	"disableSelect": `AwscCallDispositionPopup-module__disable-select___AWUMN`,
	"breakWord": `AwscCallDispositionPopup-module__break-word___aXWsY`,
	"popupClearBtn": `AwscCallDispositionPopup-module__popup-clear-btn___SkPW8`,
	"scrollMB20": `AwscCallDispositionPopup-module__scroll-m-b-20___JYUrb`,
	"container": `AwscCallDispositionPopup-module__container___F8Jyx`,
	"radioItem": `AwscCallDispositionPopup-module__radioItem___MOAXZ`,
	"buttonsContainer": `AwscCallDispositionPopup-module__buttonsContainer___pCDXa`
};
module.exports = ___CSS_LOADER_EXPORT___;
